import images from '../../../Utils/images';
import Form from 'react-bootstrap/Form';
import { ListGroup } from 'react-bootstrap';
import { useState, useEffect, useRef, useCallback } from 'react';
import InputGroup from 'react-bootstrap/InputGroup';
import colors from '../../../Utils/colors';
import { Checkbox, CircularProgress } from '@mui/material';
import { useSelector } from 'react-redux';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import PreviewCustomTemplate from '../../CustomTemplate/Preview';
import CheerioButton from '../../../Components/CheerioButton';
import { RiDeleteBin6Line } from "react-icons/ri";
import { Tooltip } from "@mui/material";
import 'primeicons/primeicons.css';
import { AiOutlineSearch } from 'react-icons/ai';
const SendWACatalogModal = ({ data, setData, setBtnDisabled }) => {
    const authtoken = useSelector((state) => state.main.auth_token);
    const [products, setProducts] = useState(''); // Default to an empty state initially
    const [agentData, setAgentData] = useState([]);
    const [assignments, setAssignments] = useState([]);
    const [userAssignPopup, setShowUserAssignPopup] = useState(true);
    const [bodyText, setBodyText] = useState('');
    const [footerText, setFooterText] = useState('');
    const localdata = useSelector((state) => state.main.localdata);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const catalogId = localdata?.whatsapp_credentials?.activeCatalogId;
    const ai_sensy_token = localdata?.whatsapp_credentials?.ai_sensy_token;
    const [searchTerm, setSearchTerm] = useState('');
    const [showList, setShowList] = useState(false);
    const [searchProducts, setSearchProducts] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [sections, setSections] = useState([]);
    const [sectionList, setSectionList] = useState([]);
    const [isSectionCreated, setIsSectionCreated] = useState(false);
    const [selectedSelections, setSelectedSections] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [showOnlySelected, setShowOnlySelected] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [beforeParam, setBeforeParam] = useState('');
    const [afterParam, setAfterParam] = useState('');
    const [expandedSections, setExpandedSections] = useState({});
    const [hoveredProductId, setHoveredProductId] = useState(null);
    const totalSelectedProducts = sections.reduce((total, section) =>
        total + (section.selectedProducts?.length || 0), 0);
    const observer = useRef();
    const sectionObservers = useRef({});
    
    const searchTimeoutRef = useRef(null);
    const sectionSearchTimeoutRef = useRef({});
    const [sectionOk, setSectionOk] = useState(false);

    const getProducts = async (catalogId, beforeParam = '', afterParam = '', isInitial = false, searchTermInput = '') => {
        setIsLoading(true);
        const url = new URL('https://backend.aisensy.com/direct-apis/t1/product');
        const params = {
            catalogId: catalogId,
            before: beforeParam || '',
            after: afterParam || ''
        };
        
        if (searchTermInput) {
            params.filter = JSON.stringify({
                name: { contains: searchTermInput }
            });
        }
        
        url.search = new URLSearchParams(params).toString();

        const options = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${ai_sensy_token}`
            }
        };

        try {
            const response = await fetch(url, options);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const responseData = await response.json();

            if (responseData?.paging) {
                setBeforeParam(responseData?.paging?.before || '');
                setAfterParam(responseData?.paging?.after || '');
                setHasMore(!!responseData.paging.after);
            } else {
                setHasMore(false);
            }

            const newProducts = responseData && Array.isArray(responseData.products) ? responseData.products : [];

            if (isInitial) {
                setFilteredProducts(newProducts);
                setSearchProducts(newProducts);
                const uniqueProducts = newProducts?.reduce((acc, product) => {
                    if (!acc.find(p => p.id === product.id)) {
                        acc.push({ ...product, selected: false });
                    }
                    return acc;
                }, []);
                setSectionList(uniqueProducts || []);
            } else {
                setFilteredProducts(prevProducts => {
                    const prevProductsArray = Array.isArray(prevProducts) ? prevProducts : [];
                    const combinedProducts = [...prevProductsArray, ...newProducts];
                    return combinedProducts.filter((product, index, self) =>
                        index === self.findIndex(p => p.id === product.id)
                    );
                });

                setSearchProducts(prevProducts => {
                    const prevProductsArray = Array.isArray(prevProducts) ? prevProducts : [];
                    const combinedProducts = [...prevProductsArray, ...newProducts];
                    return combinedProducts.filter((product, index, self) =>
                        index === self.findIndex(p => p.id === product.id)
                    );
                });

                setSectionList(prevList => {
                    const prevListArray = Array.isArray(prevList) ? prevList : [];
                    const updatedList = [...prevListArray];
                    newProducts.forEach(product => {
                        if (!updatedList.find(p => p.id === product.id)) {
                            updatedList.push({ ...product, selected: false });
                        }
                    });
                    return updatedList;
                });
            }

            setSections(prevSections => {
                if (!Array.isArray(prevSections)) return [];
                return prevSections.map(section => {
                    if (!section) return section;
                    
                    const updatedProducts = Array.isArray(section.products) ? [...section.products] : [];

                    newProducts.forEach(product => {
                        if (!updatedProducts.find(p => p.id === product.id)) {
                            updatedProducts.push({ ...product, selected: false });
                        }
                    });

                    return {
                        ...section,
                        products: updatedProducts
                    };
                });
            });

            setIsLoading(false);
        } catch (error) {
            console.error('Error fetching products:', error);
            setIsLoading(false);
            setHasMore(false);
        }
    };

    useEffect(() => {
        if (!sections || !Array.isArray(sections) || sections.length === 0) {
          setSectionOk(false);
          return;
        }
        
        const allSectionsValid = sections.every(section => 
          section?.name?.trim() !== "" &&
          Array.isArray(section.selectedProducts) &&
          section.selectedProducts.length > 0
        );
        
        setSectionOk(allSectionsValid);
      }, [sections]);


        useEffect(() => {
        if (products === "multiProduct" && sections.length > 0) {
            sections.forEach(section => {
                fetchSectionProducts(section.id, '', '', '', true);
            });
        }
    }, [products, sections.length]);

    const debouncedSearch = (searchValue) => {
        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }

        searchTimeoutRef.current = setTimeout(() => {
            setAfterParam('');
            setBeforeParam('');
            setHasMore(true);
            
            if (searchValue === '') {
                getProducts(catalogId, '', '', true);
            } else {
                getProducts(catalogId, '', '', true, searchValue);
            }
        }, 500);
    };

    const lastProductRef = useCallback(node => {
        if (isLoading) return;
        if (observer.current) observer.current.disconnect();

        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMore) {
                loadMoreProducts();
            }
        });

        if (node) observer.current.observe(node);
    }, [isLoading, hasMore, searchTerm]);

    const loadMoreProducts = () => {
        if (!isLoading && hasMore) {
            getProducts(catalogId, '', afterParam, false, searchTerm);
        }
    };

    const fetchSectionProducts = async (sectionId, searchTerm = '', beforeParam = '', afterParam = '', isInitial = false) => {
    if (!sectionId || !Array.isArray(sections)) return;
    
    const sectionIndex = sections.findIndex((section) => section && section.id === sectionId);
        if (sectionIndex === -1) return;

        setSections((prevSections) => {
        if (!Array.isArray(prevSections)) return [];
        
            const updatedSections = [...prevSections];
        if (updatedSections[sectionIndex]) {
            updatedSections[sectionIndex] = {
                ...updatedSections[sectionIndex],
                isLoading: true
            };
        }
            return updatedSections;
        });

        const url = new URL('https://backend.aisensy.com/direct-apis/t1/product');
        const params = {
            catalogId: catalogId || '',
            before: beforeParam || '',
            after: afterParam || ''
        };

        if (searchTerm) {
            params.filter = JSON.stringify({
                name: { contains: searchTerm }
            });
        }

        url.search = new URLSearchParams(params).toString();

        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${ai_sensy_token}`
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const responseData = await response.json();
            const newProducts = Array.isArray(responseData?.products) ? responseData.products : [];

            setSections((prevSections) => {
                if (!Array.isArray(prevSections)) return [];
                const updatedSections = [...prevSections];
                const sectionIndex = updatedSections.findIndex(s => s && s.id === sectionId);
                if (sectionIndex !== -1) {
                const section = {...(updatedSections[sectionIndex] || {})};

                if (isInitial) {
                    section.products = newProducts.map(p => ({ ...p, selected: false }));
                } else {
                    const existingProducts = Array.isArray(section.products) ? section.products : [];
                    const combinedProducts = [...existingProducts];
                    
                    newProducts.forEach(product => {
                        if (!combinedProducts.find(p => p.id === product.id)) {
                            combinedProducts.push({ ...product, selected: false });
                        }
                    });
                    
                    section.products = combinedProducts;
                }

                section.beforeParam = responseData?.paging?.before || '';
                section.afterParam = responseData?.paging?.after || '';
                section.hasMore = !!(responseData?.paging?.after);
                section.isLoading = false;

                updatedSections[sectionIndex] = section;
            }
                return updatedSections;
            });
        } catch (error) {
            console.error('Error fetching section products:', error);
            setSections((prevSections) => {
            if (!Array.isArray(prevSections)) return [];
            
                const updatedSections = [...prevSections];
            const sectionIndex = updatedSections.findIndex(s => s && s.id === sectionId);
            
            if (sectionIndex !== -1) {
                updatedSections[sectionIndex] = {
                    ...(updatedSections[sectionIndex] || {}),
                    isLoading: false,
                    hasMore: false
                };
            }
                return updatedSections;
            });
        }
    };

    const debouncedSectionSearch = (sectionId, searchValue) => {
        if (sectionSearchTimeoutRef.current[sectionId]) {
            clearTimeout(sectionSearchTimeoutRef.current[sectionId]);
        }

        sectionSearchTimeoutRef.current[sectionId] = setTimeout(() => {
            fetchSectionProducts(sectionId, searchValue, '', '', true);
        }, 500);
    };

    const lastProductElementRef = useCallback((sectionId) => (node) => {
        const section = sections.find(s => s.id === sectionId);
        if (!section || section.isLoading || !section.hasMore) return;

        if (sectionObservers.current[sectionId]) {
            sectionObservers.current[sectionId].disconnect();
        }

        sectionObservers.current[sectionId] = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && section.hasMore) {
                loadMoreSectionProducts(sectionId);
            }
        }, { threshold: 0.5 });

        if (node) {
            sectionObservers.current[sectionId].observe(node);
        }
    }, [sections]);

    const loadMoreSectionProducts = (sectionId) => {
        const section = sections.find((section) => section.id === sectionId);
        if (section && !section.isLoading && section.hasMore) {
            fetchSectionProducts(sectionId, section.searchTerm || '', '', section.afterParam);
        }
    };



    const createNewSection = () => {
    const safeFilteredProducts = Array.isArray(filteredProducts) 
        ? filteredProducts.map(product => ({ ...product, selected: false }))
        : [];
        
        const newSection = {
            id: (sections?.length || 0) + 1,
            products: safeFilteredProducts,
            selectedProducts: [],
            hasMore: hasMore,
            afterParam: afterParam || '',
            beforeParam: beforeParam || '',
            isLoading: false,
            searchTerm: '',
            name: "", 
        };
        setSections(prevSections => Array.isArray(prevSections) ? [...prevSections, newSection] : [newSection]);
        const newExpandedSections = { ...(expandedSections || {}) };
    
    if (Array.isArray(sections)) {
        sections.forEach(section => {
            if (section) newExpandedSections[section.id] = false;
        });
    }
    
        newExpandedSections[newSection.id] = true;
        setExpandedSections(newExpandedSections);
    };

    useEffect(() => {
        getProducts(catalogId, '', '', true);
    }, []);

    useEffect(() => {
        if (data?.completeCatalogSelected) {
            setProducts("allProducts");
        }
        else if (data?.sections?.length > 0) {
            const initialSections = data.sections.map(savedSection => ({
            id: savedSection.id,
            name: savedSection.name || "",
            selectedProducts: savedSection.selectedProducts || [],
            products: [],
            hasMore: true,
            afterParam: '',
            beforeParam: '',
            isLoading: false,
            searchTerm: ''
        }));
            // setSections(data?.sections);
            setSections(initialSections);
            setProducts("multiProduct");
            const newExpandedSections = {};
        initialSections.forEach(section => {
            newExpandedSections[section.id] = false;
        });
        setExpandedSections(newExpandedSections);
        } else {
            setProducts("singleProduct");
            setSelectedProduct(data?.product);
        }
        if (data?.message) {
            setBodyText(data?.message);
        }
        if (data?.footerText) {
            setFooterText(data?.footerText);
        }
    }, []);

    useEffect(() => {
        return () => {
            if (observer.current) {
                observer.current.disconnect();
            }
            
            Object.values(sectionObservers.current).forEach(observer => {
                if (observer) observer.disconnect();
            });

            if (searchTimeoutRef.current) {
                clearTimeout(searchTimeoutRef.current);
            }
            
            Object.values(sectionSearchTimeoutRef.current).forEach(timeout => {
                if (timeout) clearTimeout(timeout);
            });
        };
    }, []);

    useEffect(() => {
        if (products === "allProducts") {
            setData({ completeCatalogSelected: true, message: bodyText, footerText: footerText });
            if (bodyText) {
                setBtnDisabled(false);
            } else {
                setBtnDisabled(true);
            }
        } else if (products === "multiProduct") {
            const essentialSections = Array.isArray(sections) ? sections.map(section => ({
            id: section?.id,
            name: section?.name,
            selectedProducts: section?.selectedProducts || []
        })) : [];


            setData({ completeCatalogSelected: false, message: bodyText, footerText: footerText, sections: essentialSections });
            if (bodyText && sections?.length > 0 && sectionOk) {
                setBtnDisabled(false);
            } else {
                setBtnDisabled(true);
            }
        } else {
            setData({ completeCatalogSelected: false, message: bodyText, footerText: footerText, product: selectedProduct });
            if (bodyText && selectedProduct) {
                setBtnDisabled(false);
            } else {
                setBtnDisabled(true);
            }
        }
    }, [products, selectedProduct, bodyText, footerText, sections, sectionOk]);


 const handleCheckboxChange = (sectionId, product) => {
    if (!product) return;
    setSections((prevSections) => {
            if (!Array.isArray(prevSections)) return [];
            
            return prevSections.map(section => {
                if (!section || section.id !== sectionId) return section;
                const selectedProducts = Array.isArray(section.selectedProducts) ? section.selectedProducts : [];
                const isSelected = selectedProducts.some(p => p && p.id === product.id);
                
                const updatedSelectedProducts = isSelected
                    ? selectedProducts.filter(p => p && p.id !== product.id)
                    : [...selectedProducts, { ...product }];
                    
                return { ...section, selectedProducts: updatedSelectedProducts };
            });
        });
};

    const handleModeChange = (e) => {
        setProducts(e.target.value);
        setSearchTerm('');
        setSearchProducts([]);
        setShowList(false);
        setSelectedProduct(null);
        setAfterParam('');
        setBeforeParam('');
        setHasMore(true);
    };
    const handleBodyText = (e) => {
        setBodyText(e.target.value);
    };
    
    const handleFooterText = (e) => {
        setFooterText(e.target.value);
    };
    const handleFocus = () => {
        setSearchProducts(filteredProducts);
        setShowList(true);
    };
    const handleInputChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        debouncedSearch(value);
    };

    const handleItemClick = (product) => {
        setSelectedProduct(product);
        console.log('product', product);
        console.log('selected', selectedProduct);
        setShowList(false);
    };

    const deleteSection = (sectionId) => {
        if (sectionObservers.current[sectionId]) {
            sectionObservers.current[sectionId].disconnect();
            delete sectionObservers.current[sectionId];
        }
        
        if (sectionSearchTimeoutRef.current[sectionId]) {
            clearTimeout(sectionSearchTimeoutRef.current[sectionId]);
            delete sectionSearchTimeoutRef.current[sectionId];
        }
        
        setSections(prevSections => {
            if (!Array.isArray(prevSections)) return [];
            return prevSections.filter(section => section && section.id !== sectionId);
        });
    };

    const toggleSection = (sectionId) => {
        setExpandedSections((prev) => ({
            ...prev,
            [sectionId]: !prev[sectionId],
        }));
    };

    const handleSectionSearch = (sectionId, searchTerm) => {
        setSections((prevSections) =>
            prevSections.map((section) => {
                if (section?.id === sectionId) {
                    return { ...section, searchTerm };
                }
                return section;
            })
        );

        debouncedSectionSearch(sectionId, searchTerm);
    };

    const deselectAllProducts = (sectionId) => {
        setSections((prevSections) =>
            prevSections.map((section) => {
                if (section.id === sectionId) {
                    return { ...section, selectedProducts: [] };
                }
                return section;
            })
        );
    };

    const sectionStyle = {
        border: '1px solid #ddd',
        padding: '20px',
        marginBottom: '20px',
        borderRadius: '8px'
    };
    const sectionHeaderStyle = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '15px'
    };

    const productItemStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: '10px 0',
        borderBottom: '1px solid #ddd'
    };

    const productImageStyle = {
        width: '40px',
        height: '40px',
        marginRight: '10px',
        objectFit: 'cover',
        borderRadius: '4px'
    };

    const productDetailsStyle = {
        display: 'flex',
        flexDirection: 'column'
    };

    const loadingStyle = {
        display: 'flex',
        justifyContent: 'center',
        padding: '10px 0'
    };
    return (
        <div>
            <Form.Group className="mb-3" style={{ width: '100%', marginBlock: 16 }}>
                <Form.Label htmlFor="dropdown" style={{ fontWeight: 'bold', marginBottom: 8, display: 'block' }}>
                    Select type of product list
                </Form.Label>
                <InputGroup>
                    <Form.Select
                        id="dropdown"
                        className='w-100 btncustom dropdown'
                        style={{ borderRadius: 8, fontSize: 16, fontWeight: 400, color: colors.black02 }}
                        onChange={handleModeChange}
                        value={products}
                    >
                        <option disabled value="">
                            Select
                        </option>
                        <option value={'allProducts'} key={'All products/Whole catalog'}>
                            {'All products/Whole catalog'}
                        </option>
                        <option value={'singleProduct'} key={'Single product'}>
                            {'Single product'}
                        </option>
                        <option value={'multiProduct'} key={'Multi product'}>
                            {'Multi product'}
                        </option>
                    </Form.Select>
                </InputGroup>
            </Form.Group>
            {products === 'allProducts' && (<div>
                <Form.Group className="mb-3" style={{ width: '100%', marginBlock: 16 }}>
                    <Form.Label htmlFor="textInput" style={{ fontWeight: 'bold', marginBottom: 8, display: 'block' }}>
                        Body Text:
                    </Form.Label>
                    <InputGroup>
                        <Form.Control
                            id="textInput"
                            type="text"
                            className="w-100 btncustom"
                            style={{ borderRadius: 8, fontSize: 16, fontWeight: 400, color: colors.black02 }}
                            onChange={handleBodyText}
                            value={bodyText}
                            placeholder="Enter Body Text Here..."
                        />
                    </InputGroup>
                    <Form.Label htmlFor="textInput" style={{ fontWeight: 'bold', marginBottom: 8, display: 'block' }}>
                        Footer Text:
                    </Form.Label>
                    <InputGroup>
                        <Form.Control
                            id="textInput"
                            type="text"
                            className="w-100 btncustom"
                            style={{ borderRadius: 8, fontSize: 16, fontWeight: 400, color: colors.black02 }}
                            onChange={handleFooterText}
                            placeholder="Enter Footer Text Here..."
                            value={footerText}
                        />
                    </InputGroup>
                    <div
                        className="w-100 d-flex flex-column justify-content-start align-items-center WAPreviewScroll"
                        style={{
                            flex: 1,
                            border: `1px solid ${colors.borderwhite}`,
                            marginBlockEnd: 16,
                            marginBlockStart: 8,
                            borderRadius: 16,
                            overflowY: 'auto',
                        }}
                    >
                        <h4 style={{ fontSize: 16, fontWeight: 700, color: colors.black, paddingTop: '3%' }}>
                            {'Message Preview'}
                        </h4>
                        <div
                        >
                            <PreviewCustomTemplate
                                body={{
                                    type: "BODY",
                                    text: `${bodyText}` || "Now shop for your favourite products right here on whatsapp.",
                                    example: {
                                        body_text: [],
                                    },
                                }}
                                header={{
                                    type: "HEADER",
                                    format: "IMAGE",
                                    example: {
                                        header_text: [],
                                        header_handle: [],
                                    },
                                }}
                                footerData={{
                                    type: "FOOTER",
                                    text: `${footerText}` || "Now shop for your favourite products right here on whatsapp.",
                                }}
                                buttonData={{
                                    type: "BUTTONS",
                                    buttons: [{ type: "QUICK_REPLY", text: "View Catalog" }],
                                }}
                                MultiproductCatalog  = {true}
                            />
                        </div>
                    </div>
                </Form.Group>
            </div>
            )}
        {products === 'singleProduct' && (<div>
                <Form.Group className="mb-3" style={{ width: '100%', marginBlock: 16 }}>                  
                    <Form.Label htmlFor="textInput" style={{ fontWeight: 'bold', marginBottom: 8, display: 'block' }}>
                        Body Text:
                    </Form.Label>
                    <InputGroup>
                        <Form.Control
                            id="textInput"
                            type="text"
                            className="w-100 btncustom"
                            style={{ borderRadius: 8, fontSize: 16, fontWeight: 400, color: colors.black02 }}
                            onChange={handleBodyText}
                            value={bodyText}
                            placeholder="Enter Body Text Here..."
                            maxLength={1024}
                        />
                    </InputGroup>
                    <Form.Label htmlFor="textInput" style={{ fontWeight: 'bold', marginBottom: 8, display: 'block',marginTop: 12 }}>
                        Footer Text (Optional):
                    </Form.Label>
                    <InputGroup>
                        <Form.Control
                            id="textInput"
                            type="text"
                            className="w-100 btncustom"
                            style={{ borderRadius: 8, fontSize: 16, fontWeight: 400, color: colors.black02 }}
                            onChange={handleFooterText}
                            value={footerText}
                            placeholder="Enter Footer Text Here..."
                        />
                    </InputGroup>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8,marginTop: 8,marginBottom: 8 }}>
                    <img
                                    style={{
                                        height: 22,
                                        width: 22,
                                        objectFit: 'contain',
                                        cursor: 'pointer',
                                    }}
                                    src={images.InfoCircle}
                                    alt="info"
                                />
                        <p style={{ margin: 0 }}>
                Please type at least one word of the product to search
                </p>
                        </div>
                    <Form.Label htmlFor="productSearch" style={{ fontWeight: 'bold', marginBottom: 8, display: 'block' }}>
                        Select product
                    </Form.Label>
                    
                      <InputGroup className="mb-3">
                                            <InputGroup.Text className="bg-white border-end-0">
                                                <AiOutlineSearch size={18} color="#999" />
                                            </InputGroup.Text>
                                            <Form.Control
                                                type="text"
                                                placeholder="Search products..."
                                                value={searchTerm}
                                                onFocus={handleFocus}

                                                onChange={handleInputChange}
                                                className="border-start-0"
                                            />
                                        </InputGroup>

                                            {selectedProduct && (
                                                 <div style={{ 
                                                    marginTop: 8, 
                                                    marginBottom: 12, 
                                                    padding: '8px 12px', 
                                                    backgroundColor: colors.white04, 
                                                    borderRadius: 6, 
                                                    display: 'flex', 
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    border: '1px solid #d9e8f6'
                                                }}>
                                            
                                            <div style={{ display: 'flex', alignItems: 'center' }} onMouseDown={() => handleItemClick(product)}>
                                    {selectedProduct?.image_url ? (
                                        <img
                                            src={selectedProduct?.image_url}
                                            alt={selectedProduct?.name}
                                            style={{ width: 40, height: 40, marginRight: 10, objectFit: 'cover', borderRadius: 4 }}
                                        />
                                    ) : (
                                        <div style={{ 
                                            width: 40, 
                                            height: 40, 
                                            marginRight: 10, 
                                            backgroundColor: '#f0f0f0',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: 10,
                                            borderRadius: 4
                                        }}>No img</div>
                                    )}
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                        <div style={{ marginBottom: 4, fontWeight: 500 }}>
                                            {selectedProduct?.name}
                                        </div>
                                        <div style={{ fontSize: 12, color: '#666666' }}>
                                            {selectedProduct?.retailer_id}
                                        </div>
                                    </div>
                                </div>
                                
                                          <RiDeleteBin6Line
                                            style={{ cursor: 'pointer', color: '#dc3545' }}
                                            onClick={() => setSelectedProduct(null)}
                                            size={20}
                                        />
                                </div>
                                )}
                                {showList && (
                                <div style={{ fontSize: 14, marginBottom: 8 ,fontWeight:500}}>
                                    Total products: {searchProducts?.length}
                                </div>
                                )}
                   
                    {showList && (
                        <ListGroup style={{ maxHeight: 200, overflowY: 'auto', marginTop: 8 }}>
                    {searchProducts?.length === 0 && !isLoading && (
                        <ListGroup.Item>No products found</ListGroup.Item>
                    )}
                    {searchProducts?.map((product, index) => {
                        const isLastItem = index === searchProducts?.length - 1;
                        
                        return (
                            <ListGroup.Item
                                key={product.id}
                                ref={isLastItem ? lastProductRef : null}
                                onMouseEnter={() => setHoveredProductId(product.id)}
                                onMouseLeave={() => setHoveredProductId(null)}
                                onMouseDown={() => handleItemClick(product)}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    padding: '10px 16px',
                                    borderBottom: '1px solid #ddd',
                                    cursor: 'pointer',
                                    backgroundColor:
                                        selectedProduct?.id === product.id
                                            ? '#f0f8ff'
                                            : hoveredProductId === product.id
                                            ? '#f5faff'
                                            : '#fff',
                                    transition: 'background-color 0.2s ease'
                                }}
                            >
                                <div style={{ display: 'flex', alignItems: 'center' }} onMouseDown={() => handleItemClick(product)}>
                                    {product?.image_url ? (
                                        <img
                                            src={product?.image_url}
                                            alt={product?.name}
                                            style={{ width: 40, height: 40, marginRight: 10, objectFit: 'cover', borderRadius: 4 }}
                                        />
                                    ) : (
                                        <div style={{ 
                                            width: 40, 
                                            height: 40, 
                                            marginRight: 10, 
                                            backgroundColor: '#f0f0f0',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: 10,
                                            borderRadius: 4
                                        }}>No img</div>
                                    )}
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                        <div style={{ marginBottom: 4, fontWeight: 500 }}>
                                            {product.name}
                                        </div>
                                        <div style={{ fontSize: 12, color: '#666666' }}>
                                            {product.retailer_id}
                                        </div>
                                    </div>
                                </div>
                            </ListGroup.Item>
                        );
                    })}
                    {isLoading && (
                        <div style={{ display: 'flex', justifyContent: 'center', padding: '10px 0' }}>
                            <CircularProgress size={24} />
                        </div>
                    )}
                        </ListGroup>
                    )}
                    <div
                        className="w-100 d-flex flex-column justify-content-start align-items-center WAPreviewScroll"
                        style={{
                            flex: 1,
                            border: `1px solid ${colors.borderwhite}`,
                            marginBlockEnd: 16,
                            marginBlockStart: 8,
                            borderRadius: 16,
                            overflowY: 'auto',
                        }}
                    >
                        <h4 style={{ fontSize: 16, fontWeight: 700, color: colors.black, paddingTop: '3%' }}>
                            {'Message Preview'}
                        </h4>
                        <div>
                            <PreviewCustomTemplate
                                body={{
                                    type: "BODY",
                                    text: `${bodyText}` || "Now shop for your favourite products right here on whatsapp.",
                                    example: {
                                        body_text: [],
                                    },
                                }}
                                header={{
                                    type: "HEADER",
                                    format: "IMAGE",
                                    image_url: selectedProduct?.image_url || images.Dummy,
                                    example: {
                                        header_text: [],
                                        header_handle: [],
                                    },
                                }}
                                footerData={{
                                    type: "FOOTER",
                                    text: `${footerText}` || "Now shop for your favourite products right here on whatsapp.",
                                }}
                                buttonData={{
                                    type: "BUTTONS",
                                    buttons: [{ type: "QUICK_REPLY", text: "View" }],
                                }}
                            />
                        </div>
                    </div>
                </Form.Group>
            </div>)}
            {products === 'multiProduct' && (<div>
                <Form.Group className="mb-3" style={{ width: '100%', marginBlock: 16 }}>
                    <Form.Label htmlFor="textInput" style={{ fontWeight: 'bold', marginBottom: 8, display: 'block' }}>
                        Body Text:
                    </Form.Label>
                    <InputGroup>
                        <Form.Control
                            id="textInput"
                            type="text"
                            className="w-100 btncustom"
                            style={{ borderRadius: 8, fontSize: 16, fontWeight: 400, color: colors.black02 }}
                            onChange={handleBodyText}
                            value={bodyText}
                            placeholder="Enter Body Text Here..."
                        />
                    </InputGroup>
                    <Form.Label htmlFor="textInput" style={{ fontWeight: 'bold', marginBottom: 8, display: 'block', marginTop: 12 }}>
                        Footer Text (Optional)
                    </Form.Label>
                    <InputGroup>
                        <Form.Control
                            id="textInput"
                            type="text"
                            className="w-100 btncustom"
                            style={{ borderRadius: 8, fontSize: 16, fontWeight: 400, color: colors.black02 }}
                            onChange={handleFooterText}
                            placeholder="Enter Footer Text Here..."
                            value={footerText}
                        />
                    </InputGroup>
                    <div style={{ marginTop: 20 }}>
                        {Array.isArray(sections) && sections?.map((section) => (
                            <div key={section.id} style={sectionStyle} className="section">
                                <div style={sectionHeaderStyle}>
                                    <h4
                                        onClick={() => toggleSection(section.id)}
                                        style={{ cursor: 'pointer', margin: 0, display: 'flex', alignItems: 'center' }}
                                    >
                                        {section?.name && section?.name?.length > 0 ? (
                                            section.name
                                        ) : (
                                            `Section ${section.id}`
                                        )}
                                        <i
                                            className={`pi ${expandedSections[section.id] ? 'pi-angle-up' : 'pi-angle-down'}`}
                                            style={{ marginLeft: 10 }}  ></i>


                                    </h4>
                                    <div>
                                        <RiDeleteBin6Line
                                            style={{ cursor: 'pointer', color: '#dc3545' }}
                                            onClick={() => deleteSection(section.id)}
                                            size={20}
                                        />
                                    </div>
                                </div>
                                
                                {expandedSections?.[section?.id] && (
                                    <div>
                                        <InputGroup>
                                            <Form.Control
                                                id="textInput"
                                                type="text"
                                                className="w-100 btncustom mb-3"
                                                maxLength={24}
                                                style={{ borderRadius: 8, fontSize: 16, fontWeight: 400, color: colors.black02 }}
                                                onChange={(e) => {
                                                    const newName = e.target.value;
                                                    setSections(prevSections =>
                                                        prevSections.map(s =>
                                                            s.id === section.id ? { ...s, name: newName } : s
                                                        )
                                                    );
                                                }}
                                                value={section.name || ""}

                                                placeholder="Enter section name"
                                            />
                                        </InputGroup>
 
                                        <InputGroup className="mb-2">
                                            <InputGroup.Text className="bg-white border-end-0">
                                                <AiOutlineSearch size={18} color="#999" />
                                            </InputGroup.Text>
                                            <Form.Control
                                                type="text"
                                                placeholder="Search products..."
                                                value={section.searchTerm || ''}
                                                onChange={(e) => handleSectionSearch(section.id, e.target.value)}
                                                className="border-start-0"
                                            />
                                        </InputGroup>
                                        <p style={{ marginTop: 6, marginBottom: 4 }}>
                                <img
                                    style={{
                                        height: 22,
                                        width: 22,
                                        objectFit: 'contain',
                                        cursor: 'pointer',
                                    }}
                                    src={images.InfoCircle}
                                    alt="info"
                                />
                            
                                            Please type at least one word of the product to search
                                        </p>
                                        <div style={sectionHeaderStyle}
                                        >
                                        <div style={{ fontWeight: 500 }}>{`All products (${section.products.length})`}</div>

                                        {section.selectedProducts?.length > 0 && (
                                            <button
                                                onClick={() => deselectAllProducts(section.id)}
                                                style={{
                                                    marginBottom: '10px',
                                                    padding: '5px 10px',
                                                    border: '1px solid #ddd',
                                                    borderRadius: '4px',
                                                    background: '#f8f9fa',
                                                    cursor: 'pointer'
                                                }}
                                            >
                                                Deselect All
                                            </button>
                                        )}
                                        </div>
                                        <hr></hr>
           
                <div style={{ sectionHeaderStyle,display: 'flex'}}>
                    <label style={{ display: 'flex', alignItems: 'center', marginRight: 20 }}>
                        <input 
                            type="radio" 
                            name="productDisplay" 
                            checked={!showOnlySelected} 
                            onChange={() => setShowOnlySelected(false)} 
                            style={{ marginRight: 8 ,cursor: 'pointer'}}
                        />
                        Show all products
                    </label>
                    <label style={{ display: 'flex', alignItems: 'center' }}>
                        <input 
                            type="radio" 
                            name="productDisplay" 
                            checked={showOnlySelected} 
                            onChange={() => setShowOnlySelected(true)} 
                            style={{ marginRight: 8 ,cursor: 'pointer'}}
                        />
                       { `Show selected products (${section.selectedProducts.length})`}
                    </label>
                </div>
                                        <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                        {(() => {
                                            let displayProducts = [...(section.products || [])];
                                            
                                            if (showOnlySelected) {
                                                displayProducts = section.selectedProducts || [];
                                            } else {
                                                const productIds = new Set(displayProducts.map(p => p.id));
                                                
                                                section.selectedProducts?.forEach(selectedProduct => {
                                                    if (!productIds.has(selectedProduct.id)) {
                                                        displayProducts.push(selectedProduct);
                                                    }
                                                });
                                            }
                                            
                                            return displayProducts?.map((product, index) => {
                                                const isLastItem = index === displayProducts.length - 1;
                                               const isHovered = hoveredProductId === product?.id;
                                            const isSelected = section.selectedProducts?.some(p => p.id === product.id);
                                            const productItemStyle = {
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'flex-start',
                                                padding: '10px 0',
                                                borderBottom: '1px solid #ddd',
                                                cursor: 'pointer',
                                                backgroundColor: isHovered ? '#f5faff' : isSelected ? '#e6f7ff' : '#fff',
                                                transition: 'background-color 0.2s ease',
                                            };
                                                    return (
                                                        <div
                                                        key={product.id}
                                                        style={productItemStyle}
                                                        ref={isLastItem && !showOnlySelected ? lastProductElementRef(section.id) : null}
                                                        onMouseEnter={() => setHoveredProductId(product.id)}
                                                        onMouseLeave={() => setHoveredProductId(null)}
                                                    >
                                                        <Checkbox
                                                            checked={isSelected}
                                                            onChange={() => handleCheckboxChange(section.id, product)}
                                                            color="primary"
                                                        />
                                                        {product?.image_url ? (
                                                            <img
                                                                src={product?.image_url}
                                                                alt={product?.name}
                                                                style={productImageStyle}
                                                            />
                                                        ) : (
                                                            <div style={{
                                                                ...productImageStyle,
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                backgroundColor: '#f0f0f0'
                                                            }}>
                                                                No img
                                                            </div>
                                                        )}
                                                        <div style={{ ...productDetailsStyle, flexGrow: 1 }}>
                                                            <span style={{ fontWeight: 500 }}>{product?.name}</span>
                                                            <span style={{ fontSize: 12, color: '#666' }}>{product?.retailer_id}</span>
                                                        </div>
                                                        <div>
                                                            <span style={{ fontWeight: 500 }}>{product?.price}</span>
                                                        </div>
                                                    </div>
                                                );
                                            });
                                        })()}
                                            
                                            {section.isLoading && (
                                                <div style={loadingStyle}>
                                                    <CircularProgress size={24} />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                    <CheerioButton
                        borderStyle={{ borderColor: colors.black, width: '98%' }}
                        textStyle={{ color: colors.black, fontWeight: 600 }}
                        btnText={sections.length > 0 ? 'Create another Section' : 'Create Section'}
                        backColor={colors.white}
                        onclick={createNewSection}
                    />
                    <div
                        className="w-100 d-flex flex-column justify-content-start align-items-center WAPreviewScroll"
                        style={{
                            flex: 1,
                            border: `1px solid ${colors.borderwhite}`,
                            marginBlockEnd: 16,
                            marginBlockStart: 8,
                            borderRadius: 16,
                            overflowY: 'auto',
                        }}
                    >
                        <h4 style={{ fontSize: 16, fontWeight: 700, color: colors.black, paddingTop: '3%' }}>
                            {'Message Preview'}
                        </h4>
                        <div

                        >
                            <PreviewCustomTemplate
                                body={{
                                    type: "BODY",
                                    text: `${bodyText}` || "Now shop for your favourite products right here on whatsapp.",
                                    example: {
                                        body_text: [], // An empty array since 'body_text' is defined as never[]
                                    },
                                }}
                                header={{
                                    type: "HEADER",
                                    format: "IMAGE",
                                    // text: "Welcome to the Header Section",
                                    example: {
                                        header_text: [], // An empty array since 'header_text' is defined as never[]
                                        header_handle: [], // An empty array since 'header_handle' is defined as never[]
                                    },
                                }}
                                footerData={{
                                    type: "FOOTER",
                                    text: `${footerText}` || "Now shop for your favourite products right here on whatsapp.",
                                }}
                                buttonData={{
                                    type: "BUTTONS",
                                    buttons: [{ type: "QUICK_REPLY", text: "View Catalog" }], // An empty array since 'buttons' is defined as never[]
                                }}
                                MultiproductCatalog  = {true}
                            />
                        </div>
                    </div>
                </Form.Group>
            </div>
        )}
    </div>
    );
}

export default SendWACatalogModal;
